module.exports = __webpack_public_path__ + "img/a.5921ebd4.jpg";